import { Center, Text3D } from "@react-three/drei";
import { RigidBody } from "@react-three/rapier";
import BostonGeneDescription from "./BostonGeneDescription.jsx";

const SIZE = 2;

export default function BostonGeneText({ position = [0, 0, 0] }) {
  return (
    <>
      <Center position={position}>
        {/* <SurfaceButtonOpen position={[0, -0.99, 8]} isActive={false} /> */}
        <BostonGeneDescription />
        <RigidBody
          type="dynamic"
          mass={0.001}
          restitution={0.2}
          friction={0.05}
          linearDamping={0.01}
          angularDamping={0.01}
          colliders="cuboid"
        >
          <group>
            <Center position={[-4, 0, -7]}>
              <Text3D
                font="/fonts/helvetiker_regular.typeface.json"
                size={SIZE}
                height={0.5}
                curveSegments={12}
                bevelEnabled
                bevelThickness={0.05}
                bevelSize={0.05}
              >
                Boston
                <meshStandardMaterial color="#02004B" />
              </Text3D>
            </Center>
            <Center position={[4, 0, -7]}>
              <Text3D
                font="/fonts/helvetiker_regular.typeface.json"
                size={SIZE}
                height={0.3}
                curveSegments={12}
                bevelEnabled
                bevelThickness={0.05}
                bevelSize={0.05}
              >
                Gene
                <meshStandardMaterial color="#EB4E46" />
              </Text3D>
            </Center>
          </group>
        </RigidBody>
      </Center>
    </>
  );
}
